<div class="modal-header">
  <h4 class="modal-title">Unmask PII Data - {{ context === 'cell' ? 'Grid Cell' : 'Form Field' }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="alert alert-warning" role="alert">
    <i appFeatherIcon data-feather="shield"></i>
    <strong>Notice:</strong> This action will be logged for compliance audit purposes. 
    Please provide a valid reason for unmasking this PII data.
  </div>

  <form [formGroup]="unhideForm" (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <label for="fieldName" class="form-label">Field Name</label>
      <input type="text" class="form-control" id="fieldName" [value]="fieldName" readonly>
    </div>

    <div class="mb-3">
      <label for="reasonId" class="form-label">Reason for Access <span class="text-danger">*</span></label>
      <select class="form-select" id="reasonId" formControlName="reasonId" 
              [class.is-invalid]="f['reasonId'].invalid && f['reasonId'].touched">
        <option value="">Select a reason...</option>
        <option *ngFor="let reason of auditReasons" [value]="reason.reasonCode">
          {{ reason.description }}
        </option>
      </select>
      <div class="invalid-feedback" *ngIf="f['reasonId'].invalid && f['reasonId'].touched">
        Please select a reason for accessing this PII data.
      </div>
    </div>

    <div class="mb-3">
      <label for="comment" class="form-label">Additional Comments <span class="text-danger">*</span></label>
      <textarea class="form-control" id="comment" rows="3" formControlName="comment" 
                placeholder="Provide detailed justification for unmasking this PII data (minimum 10 characters)"
                [class.is-invalid]="f['comment'].invalid && f['comment'].touched"></textarea>
      <div class="invalid-feedback" *ngIf="f['comment'].invalid && f['comment'].touched">
        <div *ngIf="f['comment'].errors?.['required']">Comment is required.</div>
        <div *ngIf="f['comment'].errors?.['minlength']">Comment must be at least 10 characters long.</div>
      </div>
    </div>

    <!-- <div class="alert alert-info" role="alert">
      <i class="fas fa-info-circle"></i>
      <strong>Note:</strong> This access will be recorded with your user ID, timestamp, and the reason provided.
    </div> -->
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="onSubmit()" 
          [disabled]="unhideForm.invalid || loading">
    <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
    Unmask Data
  </button>
</div> 